export default function Void() {
    return null;
}
